<template>
    <div class="page-content page-content-config">
        <div class="card mb-5 mb-3">
            <div class="card-header d-flex justify-content-between">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Cấu hình
                        hệ thống</span></h3>
                <el-tag type="success"><span class="fw-bolder">{{ tabList.length }}</span> danh mục đang hoạt
                    động</el-tag>
            </div>
            <div class="card-body">
                <el-tabs type="border-card" :tab-position="'top'" v-model="activeTab" >
                    <el-tab-pane label="Thêm" name="add" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <i class="el-icon-plus fs-4 fw-bolder pe-1"></i>
                                <span>Thêm</span>
                            </span>
                        </template>
                        <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="150px"
                            class=" d-flex flex-column">
                            <el-form-item label="Tên danh mục" prop="cTen">
                                <el-input v-model="formData.cTen"></el-input>
                            </el-form-item>
                            <el-form-item label="Loại danh mục" prop="isUrl">
                                <el-radio-group v-model="formData.isUrl">
                                    <el-radio :value="true">Đường dẫn</el-radio>
                                    <el-radio :value="false">Hệ thống</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="Đường dẫn" prop="cLink" v-if="formData.isUrl">
                                <el-input v-model="formData.cLink"></el-input>
                            </el-form-item>
                            <el-form-item label="Hệ thống" prop="cHref" v-else>
                                <el-input v-model="formData.cHref"></el-input>
                            </el-form-item>

                            <el-form-item label="Banner" prop="iconFile">
                                <el-upload action="#" list-type="picture-card" :auto-upload="false"
                                    placeholder="Chọn banner" :on-preview="handlePictureCardPreview" ref="upload"
                                    :file-list="newIconFile" accept="image/*"
                                    :on-change="(file, fileList) => handleChangeFile(file, fileList, -1)"
                                    :on-remove="(file, fileList) => handleRemoveFile(file, fileList, -1)">
                                    <div class="d-flex align-items-center justify-content-center w-100 h-100">
                                        <i class="el-icon-plus" v-if="newIconFile.length == 0"></i>
                                        <i class="el-icon-refresh" v-if="newIconFile.length > 0"></i>
                                    </div>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <div class="w-100 d-flex justify-content-end align-items-center">
                            <el-button type="warning" plain @click="handleResetForm(-1)"><i
                                    class="el-icon-refresh-left" />Đặt
                                lại</el-button>
                            <el-button type="success" @click="handleSaveForm(-1)" plain><i
                                    class="el-icon-check" />Lưu</el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane v-for="item, index in tabList" :label="item.cTen" :name="item.nMaDanhMuc" lazy>
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>{{ item.cTen }}</span>
                            </span>
                        </template>

                        <el-form :model="formDatas[index]" :rules="rules" :ref="'formDataRef' + index"
                            label-width="150px" class=" d-flex flex-column">
                            <el-form-item label="Tên danh mục" prop="cTen">
                                <el-input v-model="formDatas[index].cTen"></el-input>
                            </el-form-item>
                            <el-form-item label="Loại danh mục" prop="isUrl">
                                <el-radio-group v-model="formDatas[index].isUrl"
                                    @change="(val) => handleChangeType(val, index)">
                                    <el-radio :value="true">Đường dẫn</el-radio>
                                    <el-radio :value="false">Hệ thống</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="Đường dẫn" prop="cLink" v-if="formDatas[index].isUrl">
                                <el-input v-model="formDatas[index].cLink"></el-input>
                            </el-form-item>
                            <el-form-item label="Hệ thống" prop="cHref" v-else>
                                <el-input v-model="formDatas[index].cHref"></el-input>
                            </el-form-item>

                            <el-form-item label="Icon" prop="iconFile">
                                <el-upload action="#" list-type="picture-card" :auto-upload="false"
                                    placeholder="Chọn banner" :on-preview="handlePictureCardPreview" ref="upload"
                                    :file-list="iconFile[index]" accept="image/*"
                                    :on-change="(file, fileList) => handleChangeFile(file, fileList, index)"
                                    :on-remove="(file, fileList) => handleRemoveFile(file, fileList, index)">
                                    <div class="d-flex align-items-center justify-content-center w-100 h-100">
                                        <i class="el-icon-plus" v-if="iconFile[index].length == 0"></i>
                                        <i class="el-icon-refresh" v-if="iconFile[index].length > 0"></i>
                                    </div>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <div class="w-100 d-flex justify-content-between align-items-center">
                            <div>
                                <el-button type="danger" @click="handleDelete(item)">
                                    <i class="el-icon-delete" />Xóa danh mục</el-button>
                                <el-button type="warning" @click="handleRestoreToDefault(item.nMaDanhMuc)">
                                    <i class="el-icon-refresh" />Khôi phục mặc định</el-button>
                            </div>
                            <div>
                                <el-button type="warning" plain @click="handleResetForm(index)">
                                    <i class="el-icon-refresh-left" />Đặt lại</el-button>
                                <el-button type="success" @click="handleSaveForm(index)" plain>
                                    <i class="el-icon-check" />Lưu</el-button>
                            </div>
                        </div>

                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
            <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
        </el-dialog>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "@/permission/index";
import { Categories } from "@/store/enums/StoreEnums";
import { baseUrl } from "@/utils/global";
import { ElMessage } from "element-plus";

export default defineComponent({
    name: 'categories',
    data() {
        return {
            store: useStore(),
            tabList: [],
            formDatas: [],
            orgDatas: [],
            iconFile: [],
            dialogImageUrl: null,
            dialogVisible: false,
            formData: {
                cHref: "",
                cIcon: "",
                cLink: "",
                cTen: "",
                nTinhTrang: 1,
                isUrl: false,
                iconFile: [],
            },
            newIconFile: [],
            rules: {
                cTen: [{ required: true, message: "Bạn chưa nhập tên danh mục", trigger: "blur" }]
            },
            activeTab: "add",
        }
    },
    methods: {

        handleFindCategories() {
            this.store.dispatch(Categories.listCategories).then(res => {
                if (res.code == 200) {
                    this.iconFile = []
                    this.tabList = res.data
                    this.formDatas = res.data.map((val, index) => {
                        this.iconFile.push([])
                        this.addImageFromURL(baseUrl + val.cIcon, index)
                        /* console.log(JSON.stringify({
                            cHref: val.cHref,
                            cIcon: val.cIcon,
                            cLink: val.cLink,
                            cTen: val.cTen,
                        })) */
                        return {
                            ...val,
                            isUrl: (val.cHref == ""),
                        }
                    })
                    this.orgDatas = this.formDatas.map(val => {
                        return Object.assign({}, val)
                    })
                }
            })
        },
        handlePictureCardPreview(val) {
            this.dialogImageUrl = val.url
            this.dialogVisible = true
        },
        async handleChangeFile(file, iconFile, index) {
            if (index == -1) {
                this.newIconFile = [file]
                this.formData.iconFile = this.newIconFile
            } else {
                this.iconFile[index] = [file]
                this.formDatas[index].iconFile = this.iconFile[index]
            }
        },
        handleRemoveFile(file, iconFile, index) {
            if (index == -1) {
                this.newIconFile = []
                this.formData.iconFile = this.newIconFile
            } else {
                this.iconFile[index] = []
                this.formDatas[index].iconFile = this.iconFile[index]
            }

        },
        handleChangeType(val, index) {
            if (index == -1) {
                this.formData.cHref = ""
                this.formData.cLink = ""
            } else {
                this.formDatas[index].cHref = ""
                this.formDatas[index].cLink = ""
            }
        },
        addImageFromURL(url, index) {
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], "image.jpg", { type: blob.type });
                    this.iconFile[index].push({
                        name: file.name,
                        url: URL.createObjectURL(file),
                        status: 'success',
                        uid: Date.now(),
                        raw: file
                    });
                });
        },
        handleResetForm(index) {
            if (index == -1) {
                this.$refs.formDataRef.resetFields()
                this.newIconFile = []
            } else {
                this.$nextTick(() => {
                    this.formDatas[index] = Object.assign({}, this.orgDatas[index])
                    if (this.iconFile[index][0].status != 'success') {
                        this.iconFile[index] = []
                        this.addImageFromURL(this.baseUrl + this.formDatas[index].cIcon, index)
                    }
                })
            }
        },
        handleDelete(val) {
            this.$confirm("Bạn có chắc muốn xóa danh mục này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            }).then(() => {
                this.store.dispatch(Categories.deleteCategories, val).then(res => {
                    if (res.code == 200) {
                        this.activeTab = "add"
                        this.handleFindCategories()
                        ElMessage({ message: "Xóa danh mục thành công", type: "success" })
                    } else {
                        ElMessage({ message: "Xóa danh mục không thành công", type: "error" })
                    }
                }).catch(() => {
                    ElMessage({ message: "Xóa danh mục không thành công", type: "error" })
                })
            })
        },
        handleSaveForm(index) {
            if (index == -1) {
                this.$refs.formDataRef.validate((valid) => {
                    if (valid) {
                        const formData = new FormData();
                        const data = {
                            cHref: this.formData.cHref,
                            cIcon: this.formData.cIcon,
                            cLink: this.formData.cLink,
                            cTen: this.formData.cTen,
                            /* cDefault: JSON.stringify({
                                cTen: this.formData.cTen,
                                cHref: this.formData.cHref,
                                cLink: this.formData.cLink,
                            }), */
                            nTinhTrang: 1,
                        }
                        if (this.newIconFile.length > 0) {
                            if (this.newIconFile[0].status == "ready") {
                                formData.append('image', this.newIconFile[0].raw)
                            }
                        }
                        this.$confirm("Bạn có muốn thêm danh mục này không?", "Xác nhận", {
                            confirmButtonText: "Xác nhận",
                            cancelButtonText: "Hủy",
                            type: "warning",
                        }).then(() => {
                            formData.append('record', new Blob([JSON.stringify(data)], { type: "application/json" }))
                            this.store.dispatch(Categories.insertCategories, formData).then(res => {
                                if (res.code == 200) {
                                    this.handleFindCategories()
                                    this.handleResetForm(-1)
                                    ElMessage({ message: "Thêm danh mục thành công", type: "success" })
                                } else {
                                    ElMessage({ message: "Thêm danh mục không thành công", type: "error" })
                                }
                            }).catch(() => {
                                ElMessage({ message: "Thêm danh mục không thành công", type: "error" })
                            })
                        }).catch(() => {

                        })
                    }
                })
            }
            else {
                this.$refs["formDataRef" + index][0].validate((valid) => {
                    if (valid) {
                        this.$confirm("Bạn có chắc muốn lưu cấu hình danh mục này không?", "Xác nhận", {
                            confirmButtonText: "Xác nhận",
                            cancelButtonText: "Hủy",
                            type: "warning",
                        }).then(() => {
                            const formData = new FormData();
                            const data = {
                                nMaDanhMuc: this.formDatas[index].nMaDanhMuc,
                                cHref: this.formDatas[index].cHref,
                                cIcon: this.formDatas[index].cIcon,
                                cLink: this.formDatas[index].cLink,
                                cTen: this.formDatas[index].cTen,
                                nTinhTrang: 1,
                            }
                            if (this.iconFile[index].length > 0) {
                                if (this.iconFile[index][0].status == "ready") {

                                    formData.append('image', this.iconFile[index][0].raw)
                                }
                            }
                            formData.append('record', new Blob([JSON.stringify(data)], { type: "application/json" }))

                            this.store.dispatch(Categories.updateCategories, formData).then(res => {
                                if (res.code == 200) {
                                    this.handleFindCategories()
                                    ElMessage({ message: "Lưu cấu hình danh mục thành công", type: "success" })
                                }
                            }).catch(() => {
                                ElMessage({ message: "Lưu cấu hình danh mục không thành công", type: "error" })
                            })
                        }).catch(() => {

                        })
                    }
                })
            }
        },
        handleRestoreToDefault(val) {
            this.$confirm("Bạn có chắc muốn khôi phục mặc định danh mục này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            }).then(() => {
                this.store.dispatch(Categories.restoreToDefault, val).then(res => {
                    if (res.code == 200) {
                        ElMessage({ message: "Khôi phục mặc định thành công", type: "success" })
                        this.handleFindCategories()
                    } else {
                        ElMessage({ message: "Khôi phục mặc định không thành công", type: "error" })
                    }
                }).catch(() => {
                    ElMessage({ message: "Khôi phục mặc định không thành công", type: "error" })
                })
            })
        }
    },
    mounted() {
        this.handleFindCategories()
    }
});

</script>

<style>
.page-content-config .el-image-viewer__wrapper {
    z-index: 2003 !important;
}
</style>